import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "relative overflow-hidden rounded-2xl bg-gradient-to-br from-slate-900 via-teal-900 to-teal-700 p-6 text-white shadow-lg" }
const _hoisted_3 = { class: "relative inline-flex items-center gap-1.5 rounded-full border border-white/20 bg-white/10 px-3 py-1 text-xs font-semibold text-teal-50" }
const _hoisted_4 = { class: "relative mt-3 text-2xl font-bold tracking-tight" }
const _hoisted_5 = { class: "relative mt-2 flex flex-wrap items-baseline gap-3" }
const _hoisted_6 = { class: "text-4xl font-bold tracking-tight" }
const _hoisted_7 = { class: "text-sm font-semibold text-teal-100" }
const _hoisted_8 = { class: "relative mt-3 inline-flex items-center gap-1.5 rounded-full bg-white/10 px-3 py-1 text-xs font-semibold text-teal-50" }
const _hoisted_9 = { class: "mt-4 overflow-hidden rounded-2xl bg-white shadow-sm ring-1 ring-gray-200" }
const _hoisted_10 = { class: "flex flex-wrap items-center gap-3 border-b border-gray-100 p-4" }
const _hoisted_11 = { class: "text-base font-semibold text-gray-900" }
const _hoisted_12 = ["disabled"]
const _hoisted_13 = { class: "divide-y divide-gray-100" }
const _hoisted_14 = { class: "min-w-0 flex-1" }
const _hoisted_15 = { class: "truncate text-sm font-semibold text-gray-900" }
const _hoisted_16 = { class: "mt-0.5 truncate text-xs text-gray-500" }
const _hoisted_17 = { class: "text-base font-bold text-gray-900" }
const _hoisted_18 = {
  key: 0,
  class: "inline-flex items-center gap-1 rounded-full bg-sky-50 px-3 py-1 text-xs font-semibold text-sky-700"
}
const _hoisted_19 = ["disabled", "onClick"]
const _hoisted_20 = {
  key: 0,
  class: "size-3 animate-spin rounded-full border-2 border-white/40 border-t-white",
  "aria-hidden": "true"
}
const _hoisted_21 = { class: "border-t border-gray-100 bg-gray-50 px-4 py-3 text-xs text-gray-500" }

import { computed } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  SparklesIcon, ClockIcon, PaperAirplaneIcon,
} from '@heroicons/vue/24/solid';
import useLivviaStore from '@/store/livvia';


export default /*@__PURE__*/_defineComponent({
  __name: 'LiveResult',
  setup(__props) {

const { t } = useI18n();
const livvia = useLivviaStore();

const result = computed(() => livvia.resultData);
const isSent = (id: string) => livvia.sentCarts.has(id);
const isCharging = (id: string) => livvia.chargingCarts.has(id);

const brl = new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL', maximumFractionDigits: 0 });
const money = (n: number) => brl.format(n);

return (_ctx: any,_cache: any) => {
  return (result.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _cache[1] || (_cache[1] = _createElementVNode("div", {
            "aria-hidden": "true",
            class: "pointer-events-none absolute -right-16 -top-20 h-60 w-60 rounded-full bg-teal-300/30 blur-3xl"
          }, null, -1)),
          _createElementVNode("span", _hoisted_3, [
            _createVNode(_unref(SparklesIcon), { class: "size-3.5" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)('livvia.result.badge')), 1)
          ]),
          _createElementVNode("h2", _hoisted_4, _toDisplayString(_unref(t)('livvia.result.headline')), 1),
          _createElementVNode("div", _hoisted_5, [
            _createElementVNode("span", _hoisted_6, _toDisplayString(money(result.value.totalAmount)), 1),
            _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(t)('livvia.result.summary', { clients: result.value.clientCount })), 1)
          ]),
          _createElementVNode("span", _hoisted_8, [
            _createVNode(_unref(ClockIcon), { class: "size-3.5" }),
            _createTextVNode(" " + _toDisplayString(_unref(t)('livvia.result.timeSaved', { hours: result.value.timeSavedHours })), 1)
          ])
        ]),
        _createElementVNode("div", _hoisted_9, [
          _createElementVNode("div", _hoisted_10, [
            _createElementVNode("h3", _hoisted_11, _toDisplayString(_unref(t)('livvia.result.cartsTitle')), 1),
            _createElementVNode("button", {
              type: "button",
              class: "ml-auto inline-flex items-center gap-2 rounded-xl bg-teal-600 px-4 py-2.5 text-sm font-semibold text-white shadow-sm transition hover:bg-teal-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600 disabled:cursor-not-allowed disabled:opacity-60",
              disabled: _unref(livvia).allChargesSent,
              onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(livvia).chargeAll()))
            }, [
              _createVNode(_unref(PaperAirplaneIcon), { class: "size-4" }),
              _createTextVNode(" " + _toDisplayString(_unref(t)('livvia.result.actionChargeAll', { count: result.value.carts.length })), 1)
            ], 8, _hoisted_12)
          ]),
          _createElementVNode("ul", _hoisted_13, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(result.value.carts, (cart) => {
              return (_openBlock(), _createElementBlock("li", {
                key: cart.id,
                class: "flex flex-wrap items-center gap-3 px-4 py-3"
              }, [
                _createElementVNode("span", {
                  class: _normalizeClass(["flex size-9 shrink-0 items-center justify-center rounded-full text-sm font-bold text-white", cart.avatarClass])
                }, _toDisplayString(cart.initials), 3),
                _createElementVNode("div", _hoisted_14, [
                  _createElementVNode("p", _hoisted_15, _toDisplayString(cart.handle), 1),
                  _createElementVNode("p", _hoisted_16, _toDisplayString(cart.items), 1)
                ]),
                _createElementVNode("span", _hoisted_17, _toDisplayString(money(cart.amount)), 1),
                (isSent(cart.id))
                  ? (_openBlock(), _createElementBlock("span", _hoisted_18, [
                      _createVNode(_unref(PaperAirplaneIcon), { class: "size-3" }),
                      _createTextVNode(" " + _toDisplayString(_unref(t)('livvia.result.sentBadge')), 1)
                    ]))
                  : (_openBlock(), _createElementBlock("button", {
                      key: 1,
                      type: "button",
                      class: "inline-flex items-center gap-2 rounded-xl bg-teal-600 px-3.5 py-2 text-sm font-semibold text-white shadow-sm transition hover:bg-teal-700 focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-teal-600 disabled:cursor-not-allowed disabled:opacity-60",
                      disabled: isCharging(cart.id),
                      onClick: ($event: any) => (_unref(livvia).chargeCart(cart.id))
                    }, [
                      (isCharging(cart.id))
                        ? (_openBlock(), _createElementBlock("span", _hoisted_20))
                        : _createCommentVNode("", true),
                      _createTextVNode(" " + _toDisplayString(isCharging(cart.id) ? _unref(t)('livvia.result.actionCharging') : _unref(t)('livvia.result.actionCharge')), 1)
                    ], 8, _hoisted_19))
              ]))
            }), 128))
          ]),
          _createElementVNode("div", _hoisted_21, _toDisplayString(_unref(t)('livvia.result.footer', { shown: result.value.carts.length, total: result.value.clientCount })), 1)
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})